import { render } from "./VCard.vue?vue&type=template&id=d071618c&scoped=true"
import script from "./VCard.vue?vue&type=script&lang=js"
export * from "./VCard.vue?vue&type=script&lang=js"

import "./VCard.vue?vue&type=style&index=0&id=d071618c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d071618c"]])

export default __exports__